/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Privacy policy link injection for Shopify Forms
  document.addEventListener('DOMContentLoaded', function () {
    function injectPrivacyLink() {
      var spans = document.querySelectorAll('span._textBody_2aowh_10');
      spans.forEach(function (span) {
        if (span.textContent.trim() === 'Estoy de acuerdo con la política de privacidad') {
          span.innerHTML = 'Estoy de acuerdo con la <a href="/policies/privacy-policy" target="_blank" style="text-decoration: underline; color: inherit;">política de privacidad</a>';
        }
      });
    }

    injectPrivacyLink();

    var observer = new MutationObserver(injectPrivacyLink);
    observer.observe(document.body, { childList: true, subtree: true });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

